module.exports = __webpack_public_path__ + "img/Download (1).1eabf011.png";